//completed = page that you're on + 1

import { colors } from "../../../constants/colors";

// total = total pages + 1
function StatusBar({ bgcolor, completed, total, message }) {
  const Styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      marginBottom: "15px",
    },
    outline: {
      display: "flex",
      flexDirection: "row",
      width: "100%",
      height: "1.2rem",
      outline: `2px solid ${colors.primary}`,
    },
    messageStyles: {
      fontSize: "0.8rem",
      fontStyle: "italic",
      color: "#6d6b6b",
      marginBottom: 8,
    },
  };

  const boxes = [];
  for (let i = 0; i < total; i++) {
    if (i === total - 1) {
      boxes.push("end");
    } else if (i < completed) {
      boxes.push("show");
    } else {
      boxes.push("noshow");
    }
  }

  return (
    <div style={Styles.container}>
      <p style={Styles.messageStyles}>{message}</p>
      <div style={Styles.outline}>
        {boxes.map((box, index) => (
          <InnerBox bgcolor={bgcolor} total={total} show={box} key={index} />
        ))}
      </div>
    </div>
  );
}

function InnerBox({ bgcolor, total, show }) {
  let boxWidth = 100 / total;
  const isCompleted = show === "show" && show !== "end" ? true : false;

  const Styles = {
    box: {
      display: "flex",
      flexDirection: "row",
      width: `${boxWidth}%`,
      height: "100%",
    },
    emptyBox: {
      display: "flex",
      backgroundColor: isCompleted ? "#c2dcea" : "white",
      width: show === "end" ? "100%" : "calc(100% - 2px)",
      height: "100%",
    },
    borderBox: {
      display: "flex",
      backgroundColor: bgcolor,
      width: show === "end" ? 0 : "2px",
      height: "100%",
    },
  };
  return (
    <div style={Styles.box}>
      <div style={Styles.emptyBox}></div>
      {isCompleted && <div style={Styles.borderBox}></div>}
    </div>
  );
}

export default StatusBar;
